import * as React from 'react'
import { StoreProps, castingStoreGetMultiOpeningHours } from '../../../../services/stores/casting.store'
import { formatTime, parseTime, utilRange } from '../../../../services/utils/utils.service'
import { FloatingContainerTitle } from '../casting-styled.component'
import CastingTimePickerComponent from '../start-date/casting-time-picker-component.compoent'
import { I18nService } from '../../../../services/utils/i18n.service'

const i18nScoped = new I18nService(require('./lodging-check-in-out.component.yml'))

export default function LodgingCheckInOutComponent ({ store, data, data: { lodging, offeredService } }: StoreProps) {
  const { multiOpeningHours } = React.useMemo(() => castingStoreGetMultiOpeningHours(data), [data])
  const { minStartOpeningHour, maxEndOpeningHour } = React.useMemo(
    () => ([1, 2, 3, 4, 5, 6, 7] as const)
      .flatMap(dayId => multiOpeningHours[dayId])
      .reduce(
        (acc, curr) => ({ minStartOpeningHour: Math.min(acc.minStartOpeningHour, curr[0]), maxEndOpeningHour: Math.max(acc.maxEndOpeningHour, curr[1]) }),
        { minStartOpeningHour: 24, maxEndOpeningHour: 0 }
      ),
    [multiOpeningHours]
  )

  const { checkinValue, checkoutValue } = React.useMemo(() => {
    if (!lodging || ('id' in lodging)) return { checkinValue: null, checkoutValue: null }
    
    return {
      checkinValue: lodging.checkin_time ? parseTime(lodging.checkin_time) : null,
      checkoutValue: lodging.checkout_time ? parseTime(lodging.checkout_time) : null
    }
  }, [lodging])

  const checkinChoices = React.useMemo(
    () => utilRange(minStartOpeningHour + 1, maxEndOpeningHour, 0.25),
    [maxEndOpeningHour, minStartOpeningHour]
  )

  const checkoutChoices = React.useMemo(
    () => utilRange(minStartOpeningHour, Math.min(maxEndOpeningHour, checkinValue ?? 24) - 0.99, 0.25),
    [checkinValue, maxEndOpeningHour, minStartOpeningHour]
  )

  if (!lodging || ('id' in lodging)) return null

  return <>
    <div style={{ marginBottom: '1em', marginTop: '1m' }}>
      <FloatingContainerTitle>{ i18nScoped.t('checkin_time') }</FloatingContainerTitle>
      <CastingTimePickerComponent
        name="lodgingCheckinTime"
        values={ checkinChoices }
        value={ checkinValue }
        onChange={ value => store.setLodgingCheckinTime(formatTime(value)) } />
    </div>

    <div style={{ marginBottom: '1em' }}>
      <FloatingContainerTitle>{ i18nScoped.t('checkout_time') }</FloatingContainerTitle>
      <CastingTimePickerComponent
        name='lodgingCheckoutTime'
        values={ checkoutChoices }
        value={ checkoutValue }
        onChange={ value => store.setLodgingCheckoutTime(formatTime(value)) } />
    </div>

    { lodging.checkin_time && lodging.checkout_time && <p>
      { offeredService.service.allowed_lodging_ical_link_mode === 'in_absence_of_guest'
        ? i18nScoped.t('will_schedule_between_ranges', { checkin_time: lodging.checkin_time, checkout_time: lodging.checkout_time })
        : i18nScoped.t('will_schedule_at', { time: formatTime(parseTime(lodging[`${offeredService.lodging_ical_offset_base}_time`]) + offeredService.lodging_ical_offset / 3600) }) }
    </p> }
  </>
}
